export enum StoredProcedureSchemaEnum {
    CheckProcs = "Checks.",
    CommandProcs = "CmdProcs.",
    DeleteProcs = "DelProcs.",
    ExtractionProcs = "Extraction.",
    GetProcs = "GetProcs.",
    InsertProcs = "InsProcs.",
    InterceptionProcs = "Interception.",
    MaintenanceProcs = "Maintenance.",
    NormalisationProcs = "RawToGenericExtraction.",
    ReportProcs = "RptProcs.",
    UpdateProcs = "UpdProcs.",
}